import { createContext } from "react";
import { OrganizationSubscriptionTierEnum } from "../__generated__/graphql";

interface IAutopilotContext {
  maxNumberContactsPerAutopilotSearch: number | null;
  maxNumberContactsPerAutopilotSearchLoading: boolean;
  subscriptionTier: OrganizationSubscriptionTierEnum | null;
}

const AutopilotContext = createContext<IAutopilotContext>({
  maxNumberContactsPerAutopilotSearch: null,
  maxNumberContactsPerAutopilotSearchLoading: false,
  subscriptionTier: null,
});

export type { IAutopilotContext };
export default AutopilotContext;
